// extracted by mini-css-extract-plugin
export default {"about-image":"About_about-image__2AYEw","about-section":"About_about-section__A9ky6","about":"About_about__skyBq","about-connect":"About_about-connect__fWeu9"};